export const CheckoutCopyright = ({ customClassName = "" }) => {
  const year = new Date().getFullYear();
  return (
    <p className={`checkout-copyright ${customClassName}`}>
      All Content ©{year} Raise Marketplace, LLC All Rights Reserved. GCX and
      the GCX logo are registered trademarks belonging to Raise Marketplace,
      LLC. All trademarks not owned by GCX that appear on this site are the
      property of their respective owners. GCX is not affiliated with or related
      to any merchant or other website whose trademarks or deals appear on GCX.
      You are buying gift cards from a third party. GCX is not the seller or
      issuer of gift cards on GCX. Sale prices are set by sellers and may differ
      from the gift cards' face value.
    </p>
  );
};
